import fetch from 'features/common/fetch';

export const NAME = 'campaignSettings-startupCurve';

export const curveType = {
	BY_SUCCESS: 'BY_SUCCESS',
	BY_REPLACEMENT: 'BY_REPLACEMENT',
	BY_PLAN: 'BY_PLAN',
};

export const dialogs = {
	curveSequence: `${NAME}/curveSequence`,
};

export const fetchState = {
	get: `${fetch.constants.urls.campaignStartupCurve}.get`,
	save: `${fetch.constants.urls.campaignStartupCurve}.put.save`,
	reset: `${fetch.constants.urls.campaignStartupCurve}.put.reset`,
};
